import React from "react";
import { Skeleton } from "../../../components/ui/skeleton";

const RepositoryLoadingState = () => {
  return (
    <div className="space-y-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={`skeleton-${index}`} className="rounded-md border p-3">
          <div className="flex items-start justify-between gap-3">
            <div className="flex flex-1 items-start gap-3">
              <Skeleton className="h-9 w-9 rounded-full" />
              <div className="w-full space-y-2">
                <Skeleton className="h-4 w-56" />
                <Skeleton className="h-3 w-full max-w-xl" />
              </div>
            </div>
            <div className="flex gap-2">
              <Skeleton className="h-8 w-24" />
              <Skeleton className="h-8 w-8" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RepositoryLoadingState;
